


















































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import VueApexCharts from "vue-apexcharts";
import { patientLifeStyleModule } from "@/store/modules/patientLifeStyle";
Vue.use(VueApexCharts);


@Component({
  components: {
    VueApexCharts
  }
})
export default class RecordLifeStyle extends Vue {
  switch1 = true;
  chartOptions = null;
  series = [];
  LinechartOptions = null;
  Lineseries = [];
  stepseries = [];
  stepchartOptions = null;
  datestepseries = [];
  datestepchartOptions = null;
  startmenu = false;
  endmenu = false;
  start = new Date().toISOString().split('T')[0];
  end = new Date().toISOString().split('T')[0];
  lifeStyleOptions = {
    uuid: "",
    date: null,
    end_date: null,
  };

  async getSleep(){
    const starttimestamp = (Date.parse(this.start) / 1000) - 28800;
    const endtimestamp = (Date.parse(this.end) / 1000) - 28800 + 86399;
    this.lifeStyleOptions.date = starttimestamp;
    this.lifeStyleOptions.end_date = endtimestamp;
    await patientLifeStyleModule.getSleepByUuid(this.lifeStyleOptions);
    await patientLifeStyleModule.getStepGroupByHourByUuid(this.lifeStyleOptions);
    await patientLifeStyleModule.getStepGroupBydateByUuid(this.lifeStyleOptions);
    await this.resetChart();
    this.updataChart();
  }

  async created() {
    this.lifeStyleOptions.uuid = this.$router.currentRoute.params.id;
  }

  resetChart() {
    this.chartOptions = null;
    this.series = [];
    this.LinechartOptions = null;
    this.Lineseries = [];
    this.stepchartOptions = null;
    this.stepseries = [];
    this.datestepseries = [];
    this.datestepchartOptions = null;
  }

  updataChart() {
    this.datestepseries = [{
        name:"走路步數",
        data: this.datestepy
    }];
    this.stepseries = [{
        name: "走路步數",
        data: this.stepmerge
    }];
    this.series = [
      {
        name: "舒眠時間",
        data: this.ComfortCountdata
      },
      {
        name: "淺眠時間",
        data: this.LightCountdata
      },
      {
        name: "清醒時間",
        data: this.AwakeCountdata
      },
      {
        name: "快速動眼時間",
        data: this.RemCountdata
      },
    ];
    this.Lineseries = [
      {
        name:"翻身次數",
        data: this.Tossdata
      }
    ];
    this.chartOptions = {
      chart:{
        toolbar: {
            show: true
        },
        stacked: true,
        zoom: {
            enabled: true
        },
      },
      tooltip:{
        x:{
          show:true
        },
        y: {
          formatter: function(value, {series, seriesIndex, dataPointIndex, w}){
            return value + '分鐘';
        }
        }
      },
      responsive: [{
            breakpoint: 480,
            options: {
            legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
            }
            }
        }],
      plotOptions: {
        bar: {
        horizontal: false,
        borderRadius: 10
        },
      },
      legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        },
      xaxis: {
        categories: this.MeasureAt,
        labels:{
            formatter: function(val){
                if(typeof val === 'string')return val.split(',');
                else return val;
            }
        }
      },
      yaxis: {
        title:{
            text: "分鐘"
        },
        labels: {
          minWidth: 10
        }
      },
      grid: {
        borderColor: "#f1f1f1"
      },
      annotations:{
        points:this.barSummary
      }
    };
    this.LinechartOptions = {
      chart:{
        dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
        },
      },
      xaxis: {
        categories: this.MeasureAt,
        labels:{
            formatter: function(val){
                if(typeof val === 'string')return val.split(',');
                else return val;
            }
        }
      },
      yaxis: {
        title:{
          text:"翻身次數"
        },
        labels: {
          minWidth: 10
        }
      },
      zoom: {
        enabled: false
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        width: [3],
        curve: "straight",
        dashArray: [0]
      },
      markers: {
        size: [6],
        hover: {
          sizeOffset: 10
        }
      },
      grid: {
        borderColor: "#f1f1f1"
      },
      tooltip: {
        enabledOnSeries: [0]
      },
      colors: ['#77B6EA'],
      legend: {
          showForSingleSeries:true,
          position: 'right',
          offsetY: 40
        },
    };

    this.stepchartOptions = {
        chart:{
            id: 'stepchart',
            toolbar: {
                show: true
            },
            stacked: false,
            zoom: {
                enabled: true
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
            legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
            }
            }
        }],
      plotOptions: {
        bar: {
        horizontal: false,
        borderRadius: 10
        },
      },
      legend: {
          showForSingleSeries:true,
          position: 'right',
          offsetY: 40
        },
      fill: {
        opacity: 1
      },
      xaxis: {
        labels: {
            datetimeUTC: false
        },
        type: "datetime",
      },
      dataLabels:{
        enabled:false
      },
      yaxis: {
        title:{
          text:"走路步數"
        },
        labels: {
          minWidth: 10
        }
      },
      grid: {
        borderColor: "#f1f1f1"
      },
      tooltip:{
        x:{
            show:true,
            format: 'MM/dd HH:mm'
        },
      }
    };
    this.datestepchartOptions = {
        chart:{
            id: 'dailystepchart',
            toolbar: {
                show: true
            },
            stacked: false,
            zoom: {
                enabled: true
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
            legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
            }
            }
        }],
      plotOptions: {
        bar: {
        horizontal: false,
        borderRadius: 10
        },
      },
      legend: {
          showForSingleSeries:true,
          position: 'right',
          offsetY: 40
        },
      fill: {
        opacity: 1
      },
      xaxis: {
        categories:this.datestepx,
        tickPlacement: 'between',
      },
      dataLabels:{
        enabled:true
      },
      yaxis: {
        title:{
          text:"走路步數"
        },
        labels: {
          minWidth: 10
        }
      },
      grid: {
        borderColor: "#f1f1f1"
      },
    };
  }

  

  cancel() {
    this.resetChart();
    this.$router.push({ name: "個案紀錄" });
  }

  get sleepdata() {
    return patientLifeStyleModule.sleepdata;
  }
  get sleep_end_time_list(){
    return patientLifeStyleModule.sleep_end_time_list;
  }
  get sleep_start_time_list(){
    return patientLifeStyleModule.sleep_start_time_list;
  }

  get MeasureAt(){
    const data = [];
    this.sleep_start_time_list.forEach((num1, index)=>{
        data.push(num1+ ',至,'+ this.sleep_end_time_list[index]);
    });
    return data;
  }

  get barSummary(){
    const data = [];
    this.RemCountdata.forEach((num1, index)=>{
        const total = num1+this.ComfortCountdata[index]+this.LightCountdata[index]+this.AwakeCountdata[index];
        data.push({
            x:this.MeasureAt[index],
            y:total,
            label: {
                borderColor: '#775DD0',
                offsetY: 0,
                style: {
                color: '#fff',
                background: '#775DD0',
                },
                text: total.toString()+'分鐘',
            }
        });
    });
    return data;
  }

  get Tossdata(){
    return patientLifeStyleModule.Tossdata;
  }
  get RemCountdata(){
    return patientLifeStyleModule.RemCountdata;
  }
  get AwakeCountdata(){
    return patientLifeStyleModule.AwakeCountdata;
  }
  get LightCountdata(){
    return patientLifeStyleModule.LightCountdata;
  }
  get ComfortCountdata(){
    return patientLifeStyleModule.ComfortCountdata;
  }

  get loading() {
    return patientLifeStyleModule.loading;
  }

  get stepdata(){
    return patientLifeStyleModule.stepdata;
  }

  get stepmerge(){
    const data = [];
    this.stepMeasureAt.forEach((num1, index)=>{
        data.push({
            x: num1,
            y: this.stepdata[index]
        })
    });
    return data;
  }

  get stepMeasureAt(){
    return patientLifeStyleModule.stepmeasureat;
  }

  get datestepdata(){
    return patientLifeStyleModule.datestepdata;
  }
  get datestepy(){
    const data = [];
    this.datestepdata.forEach((val, index)=>{
        data.push(val['y']);
    });
    return data;
  }
  get datestepx(){
    const data = [];
    this.datestepdata.forEach((val, index)=>{
        const xlabel = new Date(val['x']).toISOString().split('T')[0].split('-');
        data.push(xlabel[1]+'月'+xlabel[2]+'日');
    });
    return data;
  }
}
